import { AIActions, selectAIError } from '@store/reducers/ai'
import type { AIChatErrorType } from '@store/reducers/ai/types'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import css from './styles.module.css'

const ERROR_MESSAGES: Record<AIChatErrorType, string> = {
  task_in_progress: 'Other task in progress.',
  timeout: 'Timeout error.',
  network: 'Connection lost.',
  unknown: 'Unknown error.',
}

export const AIMessageError: React.FC = () => {
  const dispatch = useDispatch()
  const error = useSelector(selectAIError)

  const onClick = () => {
    dispatch(AIActions.sendMessage({}))
  }

  return (
    <div className={css.error_container}>
      <span>{ERROR_MESSAGES[error ?? 'unknown']}</span>
      <span className={css.error_button} onClick={onClick}>
        Try again
      </span>
    </div>
  )
}
